import React, { useState } from 'react';
import apiService from '../apiService';

/**
 * « Voir la facture » (2026-10-24, demande banque) : ouvre la facture de l'achat dans un nouvel
 * onglet (page imprimable / enregistrable en PDF). La fenêtre est ouverte pendant le clic pour ne
 * pas être bloquée par le navigateur.
 */
export default function InvoiceLink({ type, id, compact = false }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  if (!id) return null;
  const open = async (e) => {
    e?.stopPropagation?.();
    setErr(''); setBusy(true);
    const w = window.open('', '_blank');
    try {
      const r = await apiService.get(`/invoices/${type}/${id}/link`);
      if (r?.url) { if (w) w.location.href = r.url; else window.location.href = r.url; }
      else { if (w) w.close(); setErr(r?.error || 'Facture indisponible'); }
    } catch (ex) {
      if (w) w.close();
      setErr(ex?.message || 'Facture indisponible');
    } finally { setBusy(false); }
  };
  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 2 }}>
      <button type="button" className={compact ? 'mk-btn ghost' : 'mk-btn ghost block'} style={compact ? { padding: '4px 10px', fontSize: 13, marginTop: 6 } : { marginTop: 8 }} onClick={open} disabled={busy}>
        {busy ? 'Ouverture…' : '🧾 Voir la facture'}
      </button>
      {err && <span className="mk-note err" style={{ fontSize: 12 }}>{err}</span>}
    </span>
  );
}
